<template>
	<div class="container-fluid">
		<div class="Titulo">Ayuda</div>


		<div class="card my-4">
			<div class="card-body">

				<div class="px-2">
					<div class=" mt-3">
						<h6 class="tituloVideos my-1">
							¿Cómo usar nuestra plataforma web?
						</h6>
						<div class="lineaTitulo"></div>						
					</div>
				</div>

				<div class="px-2">
					<div class="row mt-3">
						<div class="col-xxl-2 col-xl-3 d-none d-xl-block">
							<ul class="listaVideos">
								<li :key="vIndex" v-for="(vData, vIndex ) in listaVideos" @click="cambiaVideo(vData.indice)">
									<button :class="vActivo == vData.indice ? 'btnMuestraVideoActivo' : 'btnMuestraVideo'" >{{ vData.nombre }}</button>
								</li>
								<!--<li @click="cambiaVideo(0)">
									<button :class="vActivo == 0 ? 'btnMuestraVideoActivo' : 'btnMuestraVideo'" >Mi lista de pedido</button>
								</li>
								<li @click="cambiaVideo(1)">
									<button :class="vActivo == 1 ? 'btnMuestraVideoActivo' : 'btnMuestraVideo'" >Catálogo general</button>
								</li>
								<li @click="cambiaVideo(2)">
									<button :class="vActivo == 2 ? 'btnMuestraVideoActivo' : 'btnMuestraVideo'" >Nuevos, Ofertas y Remates</button>
								</li>
								<li @click="cambiaVideo(3)">
									<button :class="vActivo == 3 ? 'btnMuestraVideoActivo' : 'btnMuestraVideo'" >Cambio de precios</button>
								</li>
								<li @click="cambiaVideo(4)">
									<button :class="vActivo == 4 ? 'btnMuestraVideoActivo' : 'btnMuestraVideo'" >Estatus de pedidos</button>
								</li>
								<li @click="cambiaVideo(5)">
									<button :class="vActivo == 5 ? 'btnMuestraVideoActivo' : 'btnMuestraVideo'" >Adeudos</button>
								</li>
								<li @click="cambiaVideo(6)">
									<button :class="vActivo == 6 ? 'btnMuestraVideoActivo' : 'btnMuestraVideo'" >Facturas</button>
								</li>
								<li @click="cambiaVideo(7)">
									<button :class="vActivo == 7 ? 'btnMuestraVideoActivo' : 'btnMuestraVideo'" >Carrito</button>
								</li>
								<li @click="cambiaVideo(8)">
									<button :class="vActivo == 8 ? 'btnMuestraVideoActivo' : 'btnMuestraVideo'" >Pago en línea</button>
								</li> -->
							</ul>
						</div>
						<div class="col-12 d-xl-none d-xs-block">
							<b-select v-model="vActivo" :options="listaVideos" value-field="indice" text-field="nombre" v-on:change="videoActivo()" >
								<template #first>
									<b-form-select-option value="-1" disabled>Seleccionar video</b-form-select-option>
								</template>
							</b-select>
						</div>
						<div class="col-xxl-10 col-xl-9 col-xs-12">
							<div class="py-2 w-100">
								<video ref="reproductor" class="tamanoVideo" controls>
									<source :src="rutaVideo" type="video/mp4">
								</video>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="justify-content-center border bg-white my-4">
			<div class="row">
				<div class="col-12 col-lg-6">
					<div class="p-2">
						<div class="fuente-titulo py-3">Preguntas frecuentes</div>
						<div class role="tablist">
							<b-card :key="p.codigo" class="mb-1 estilo-header" no-body v-for="p in preguntasFrecuentes">
								<b-card-header header-tag="header" role="tab">
									<a
										:id="p.codigo"
										class="text-decoration-none d-flex align-items-center"
										href="#"
										v-b-toggle="'accordion-'+p.codigo"
										v-on:click="cambiaIconoEImagen(p)"
									>
										<span class="fuente-titulo">{{(p.codigo+1)+"- "+ p.pregunta}}</span>
										<span class="pl-3 ml-auto fuente-titulo">
											<i :class="'fa fa-'+p.icon"></i>
										</span>
									</a>
								</b-card-header>
								<b-collapse :id="'accordion-'+p.codigo" accordion="my-accordion" role="tabpanel">
									<b-card-body>
										<b-card-text class="fuente-respuesta">{{ p.respuesta }}</b-card-text>
									</b-card-body>
								</b-collapse>
							</b-card>
						</div>
					</div>
				</div>

				<div class="col-12 col-lg-6">
					<div class="p-2 text-center">
						<div
							class="fuente-titulo py-3 text-center font-weight-bold"
						>¿Cómo usar nuestra plataforma web?</div>
						/*<img :src="imagenSeleccionada" alt="imagen guía" class="imagen-guia" />*/
						<img alt="imagen guía" class="border git-Mobile" src="@/assets/img-priv/ayuda.gif" />
					</div>
				</div>
			</div>
		</div> -->
	</div>
</template>
<script>
	export default {
		data() {
			return {
				preguntasFrecuentes: [{
						codigo: 0,
						pregunta:
							"¿ Ad nisi tempor ad et magna magna voluptate ullamco laboris adipisicing ?",
						respuesta: `Minim quis in fugiat nulla enim dolor culpa proident sunt labore enim aliquip fugiat. Eiusmod tempor minim dolor culpa. Voluptate excepteur eu anim ad non cillum do in sint.
																																																																																											                             Ut ipsum proident ad eu non cillum nulla elit ea eiusmod qui enim laborum. Labore nostrud laboris do eiusmod officia laborum id pariatur. Ipsum ipsum voluptate ut consequat sunt tempor duis laborum.`,
						imagenURL:
							"https://via.placeholder.com/350x350?text=Imagen+de+primer+pregunta",
						icon: "angle-down",
					},
					{
						codigo: 1,
						pregunta: "¿ Culpa voluptate fugiat et esse enim in esse laborum ?",
						respuesta: `Commodo minim reprehenderit eu id est ea sunt velit qui velit. Ad aliquip eu sunt laboris. Dolore duis excepteur officia et. Magna non ex tempor proident eiusmod consectetur laboris reprehenderit excepteur magna voluptate. Pariatur aliquip eiusmod commodo nostrud quis dolore commodo qui ad elit ad amet cillum. Id ad id nisi Lorem excepteur do est officia veniam culpa tempor.
																																																																																											                             Sunt magna anim nisi laboris sit tempor quis pariatur minim laborum enim elit voluptate ea. Consequat fugiat sint pariatur ullamco exercitation sit Lorem fugiat. Consequat dolor reprehenderit ut do incididunt proident anim do sunt qui. Eiusmod adipisicing nulla culpa sit magna aliquip et dolor elit. Cupidatat consectetur irure et ut cillum. Ad eu excepteur aute excepteur in excepteur sint minim consectetur eu commodo. Reprehenderit duis aute esse pariatur.`,
						imagenURL:
							"https://via.placeholder.com/350x350?text=Imagen+de+segunda+pregunta",
						icon: "angle-down",
					},
					{
						codigo: 2,
						pregunta:
							"¿ Adipisicing voluptate qui anim laboris excepteur labore ipsum eu consectetur veniam ?",
						respuesta: `Labore ea dolore culpa velit minim aute excepteur veniam sit aliqua dolor in labore ex. Veniam deserunt in pariatur minim tempor officia exercitation est reprehenderit deserunt proident id qui culpa. Proident sunt fugiat deserunt excepteur tempor adipisicing dolore aliqua velit pariatur proident eiusmod. Officia non dolor amet occaecat minim in culpa enim duis adipisicing. Pariatur veniam magna cupidatat deserunt exercitation adipisicing amet velit duis est veniam dolor amet proident. Lorem occaecat ex minim adipisicing est elit. Reprehenderit occaecat nisi enim cupidatat deserunt officia mollit minim minim id amet veniam.
																																																																																											                             Non dolor pariatur pariatur in pariatur. Est reprehenderit quis esse in id pariatur aute pariatur. Nulla id cillum pariatur ullamco est cupidatat occaecat aute incididunt labore proident Lorem aliqua. Laboris esse sunt exercitation sit aliquip. Ex nostrud minim consequat enim eiusmod do. Anim ex aliquip incididunt aute ea pariatur magna tempor amet commodo qui eu.`,
						imagenURL:
							"https://via.placeholder.com/350x350?text=Imagen+de+tercer+pregunta",
						icon: "angle-down",
					},
				],
				imagenSeleccionada:
					"https://via.placeholder.com/350x350?text=Imagen+de+como+usar+plataforma",
				listaVideos: [
							{indice: 0, nombre:"Mi lista de pedido", ruta:"http://www.difarmer.com/imagenes/Difarmer/Videos/MiListaDePedido.mp4"},
							{indice: 1, nombre:"Catálogo general", ruta:"http://www.difarmer.com/imagenes/Difarmer/Videos/CatalogoGeneral.mp4"},
							{indice: 2, nombre:"Nuevos, Ofertas y Remates", ruta:"http://www.difarmer.com/imagenes/Difarmer/Videos/NuevosOfertasRemates.mp4"},
							{indice: 3, nombre:"Cambio de precios", ruta:"http://www.difarmer.com/imagenes/Difarmer/Videos/CambioDePrecios.mp4"},
							{indice: 4, nombre:"Estatus de pedidos", ruta:"http://www.difarmer.com/imagenes/Difarmer/Videos/EstatusDePedidos.mp4"},
							{indice: 5, nombre:"Adeudos", ruta:"http://www.difarmer.com/imagenes/Difarmer/Videos/Adeudos.mp4"},
							{indice: 6, nombre:"Facturas", ruta:"http://www.difarmer.com/imagenes/Difarmer/Videos/Facturas.mp4"},
							{indice: 7, nombre:"Carrito", ruta:"http://www.difarmer.com/imagenes/Difarmer/Videos/Carrito.mp4"},
							{indice: 8, nombre:"Pago en línea", ruta:"http://www.difarmer.com/imagenes/Difarmer/Videos/PagoEnLinea.mp4"},
							{indice: 9, nombre:"Cargar pedidos excel", ruta:"http://www.difarmer.com/imagenes/Difarmer/Videos/CargarPedidosExcel.mp4"}
							],
				rutaVideo:"",
				vActivo:-1,
			}
		},
		methods: {
			cambiaIconoEImagen(p) {
				this.imagenSeleccionada = p.imagenURL
				p.icon = p.icon == "angle-down" ? "angle-up" : "angle-down"
				this.preguntasFrecuentes.forEach((element) => {
					if (element !== p) {
						element.icon = "angle-down"
					}
				})
			},
			cambiaVideo(activo)
			{
				//console.log(activo);
				this.vActivo = activo;
				this.videoActivo()
			},
			async videoActivo()
			{
				this.rutaVideo = this.listaVideos[this.vActivo].ruta;
				this.$refs["reproductor"].load();
				await this.$refs["reproductor"].play();
			
			}
		},
		mounted() {
			this.carritoConsultarCantidad()
			this.obtenerNotificaciones()
			this.cambiaVideo(this.$route.params.activo)
		},
		created()
		{
			this.$emit('togleMenu', 7)
		},
	}
</script>
<style scoped>
	.Titulo {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
		font-weight: bold;
	}
	.estilo-header {
		border: none !important;
		background-color: var(--color-blanco) !important;
	}
	.fuente-titulo {
		font-family: "Open Sans";
		font-weight: 600;
		color: var(--bg-menu-blue);
	}
	.fuente-respuesta {
		font-family: "Open Sans";
		font-weight: lighter;
		color: var(--bg-menu-blue);
	}

	.fuente-boton {
		font-family: "Open Sans";
		color: var(--color-blanco);
	}
	.imagen-guia {
		width: 100%;
		height: 100%;
	}






	.lineaTitulo
	{
		height: 5px;
		background: #335198;
	}

	.listaVideos
	{
		list-style: none;
		padding: 15px;
	}

	.listaVideos li
	{
		font-size: 16px;
		margin-bottom: 5px;
		padding: 5px;
		text-align: left;
		cursor: pointer;
	}

	.listaVideos li:hover
	{
		background: rgb(250, 250, 250);
		border-radius: 0.5rem;
	}

	.btnMuestraVideo
	{
		border: none;
		background: transparent;
		color: #335198;
		font-weight: bold;
		padding: 0px;
		text-align: left !important;
	}

	.btnMuestraVideo:active
	{
		outline: none;
		color: #335198;
	}

	.btnMuestraVideo:focus
	{
		outline: none;
		background: transparent;
		color: #335198;		
	}
	

	.btnMuestraVideoActivo
	{
		outline: none;
		border: none;
		background: transparent;
		color: #f1c240;
		font-weight: bold;
		padding: 0px;
		text-align: left !important;
	}

	.tamanoVideo
	{
		width: 100%;
	}

	.tituloVideos
	{
		color: #335198;
		font-weight: bold;
	}

	/* video
	{
		max-width: 1000px;
		max-height: 800px;
	}
	*/

	

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.git-Mobile {
			width: 300px;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.git-Mobile {
			width: 350px;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.git-Mobile {
			width: 400px;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		.encabezado {
			margin-left: 1rem;
		}
		.git-Mobile {
			width: 320px;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		.encabezado {
			margin-left: 2rem;
		}
		.git-Mobile {
			width: 400px;
		}
	}
</style>